/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GoogleApiHttpBodyFromJSON, GoogleApiHttpBodyToJSON, } from './';
export function StreemApiUploadCompanyCallSourceLogoRequestFromJSON(json) {
    return StreemApiUploadCompanyCallSourceLogoRequestFromJSONTyped(json, false);
}
export function StreemApiUploadCompanyCallSourceLogoRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'httpBody': !exists(json, 'http_body') ? undefined : GoogleApiHttpBodyFromJSON(json['http_body']),
        'fileName': !exists(json, 'file_name') ? undefined : json['file_name'],
    };
}
export function StreemApiUploadCompanyCallSourceLogoRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'http_body': GoogleApiHttpBodyToJSON(value.httpBody),
        'file_name': value.fileName,
    };
}
//# sourceMappingURL=StreemApiUploadCompanyCallSourceLogoRequest.js.map